const KEY = 'fa_theme'

export type Theme = 'dark' | 'light'

export function getTheme(): Theme {
  return (localStorage.getItem(KEY) as Theme) || 'dark'
}

export function applyTheme(t: Theme) {
  document.documentElement.classList.toggle('light', t === 'light')
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', t === 'light' ? '#f6f2e9' : '#070510')
}

export function setTheme(t: Theme) {
  localStorage.setItem(KEY, t)
  applyTheme(t)
}

export function initTheme() {
  applyTheme(getTheme())
}
